import { interceptMspDetails } from "apis/msp.apis";
import { API_MSP_LIST_V2, PAGE_SIZE, QUERIES } from "consts";
import { useAutoFetchInfiniteQuery } from "hooks/useAutoFetchInfiniteQuery";
import { IMsp } from "types/apis/msp.types";

interface UseMspListOptions {
  includeDetails?: boolean;
  pageSize?: number;
}

export const useMspList = (options: UseMspListOptions = {}) => {
  const { includeDetails = true, pageSize = PAGE_SIZE } = options;

  const {
    data: mspList,
    hasNextPage,
    isFetching,
  } = useAutoFetchInfiniteQuery<IMsp>({
    dataKey: "mspList",
    apiUrl: API_MSP_LIST_V2,
    queryKeys: includeDetails ? [QUERIES.getMspList] : ["msp-list-dropdown"],
    dataInterceptor: includeDetails ? interceptMspDetails : undefined,
    queryParams: { includeDetails, pageSize },
  });

  const canFetchMore = hasNextPage === undefined || hasNextPage;

  return {
    mspList,
    isFetching,
    canFetchMore,
  };
};
